import { render, staticRenderFns } from "./ImportBLCntrCgoPop.vue?vue&type=template&id=52d44268"
import script from "./ImportBLCntrCgoPop.vue?vue&type=script&lang=js"
export * from "./ImportBLCntrCgoPop.vue?vue&type=script&lang=js"
import style0 from "./ImportBLCntrCgoPop.vue?vue&type=style&index=0&id=52d44268&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d44268')) {
      api.createRecord('52d44268', component.options)
    } else {
      api.reload('52d44268', component.options)
    }
    module.hot.accept("./ImportBLCntrCgoPop.vue?vue&type=template&id=52d44268", function () {
      api.rerender('52d44268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ImportBLCntrCgoPop.vue"
export default component.exports